// extracted by mini-css-extract-plugin
module.exports = {"marquee__anim":"MarqueeText_marquee__anim__X98Hu","marquee":"MarqueeText_marquee___MLV4"};